import React from 'react';
import { Box, Typography, Grid } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import IntlMessages from 'util/IntlMessages';

/**
 * Simulates a generic e-commerce site header
 */
const PseudoHeader = () => (
  <Box
    height="60px"
    bgcolor="#ffffff"
    borderBottom="1px solid #e0e0e0"
    display="flex"
    alignItems="center"
    px={3}
    justifyContent="space-between"
    color="#9e9e9e"
    flexShrink={0}
  >
    <Box display="flex" alignItems="center" gap={2}>
      <Typography variant="h6" style={{ fontWeight: 800, letterSpacing: -1, color: '#bdbdbd' }}>
        <IntlMessages id="ui.searchExperienceV2.preview.shells.resultsPageShell.brand" />
      </Typography>
    </Box>

    <Box flex={1} maxWidth="400px" mx={4}>
      <Box
        height="36px"
        bgcolor="#f5f5f5"
        borderRadius="4px"
        display="flex"
        alignItems="center"
        px={2}
        color="#bdbdbd"
      >
        <SearchIcon fontSize="small" />
        <Box ml={1} component="span" fontSize="14px"><IntlMessages id="ui.searchExperienceV2.preview.shells.resultsPageShell.query" /></Box>
      </Box>
    </Box>

    <Box width="100px" />
  </Box>
);

const PseudoFooter = () => (
  <Box height="100px" bgcolor="#eeeeee" display="flex" alignItems="center" justifyContent="center" mt={4} flexShrink={0}>
    <Typography variant="caption" style={{ opacity: 0.5 }}><IntlMessages id="ui.searchExperienceV2.preview.shells.resultsPageShell.footer" /></Typography>
  </Box>
);

const ResultsPageShell = ({ children, screen = 'desktop' }) => {
  const isMobile = screen === 'mobile';
  return (
    <Box
      height="100%"
      bgcolor="#fff"
      display="flex"
      flexDirection="column"
      overflow="hidden"
      textAlign="left"
    >
      <PseudoHeader />

      <Box flex={1} overflow="auto" display="flex" flexDirection="column">
        <Box p={isMobile ? 1 : 3} flex={1}>
          <Grid container spacing={isMobile ? 2 : 4}>
            <Grid item xs={12} md={12}>
              <Box minHeight="400px">
                {children}
              </Box>
            </Grid>
          </Grid>
        </Box>
        <PseudoFooter />
      </Box>
    </Box>
  );
};

export default ResultsPageShell;
